<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <img [src]="imgSrc" *ngIf="imgSrc != null" style="width: 100%;">
    </div>
  </div>
</div>
